// DRE por Empresa (Gestão Orçamentária): abre o DRE Gerencial por empresa jurídica.
// Espelha backend/config.py ROLES_DRE_EMPRESA / EMPRESAS_DRE / CATEGORIAS_RATEIO_EMPRESAS —
// mantenha os três em sincronia.
export const ROLES_DRE_EMPRESA = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO"];

// Só GT/CIGTA/CRIA por enquanto — deliberadamente menor que EMPRESAS_FATURAMENTO_BRUTO (que já
// inclui FLOW, ver constants/faturamentoBruto.js), porque o rateio e a cascata de imposto
// ainda não cobrem essa 4ª empresa.
export const EMPRESAS_DRE = ["GT", "CIGTA", "CRIA"];

// 7 categorias ainda não apuradas por empresa nos módulos de origem — cada uma tem um
// percentual de rateio por empresa/ano (painel de rateio, ver DreEmpresaView.js). Faturamento
// Bruto (Backlog) e Impostos ficam de fora de propósito: o primeiro já é real por empresa, o
// segundo é calculado (cascata de imposto), nenhum dos dois é rateado.
export const CATEGORIAS_RATEIO_EMPRESAS = [
  { chave: "nova_venda", label: "Nova Venda" },
  { chave: "custos_gerais", label: "Custos Gerais" },
  { chave: "custo_mao_de_obra", label: "Custo Mão de Obra" },
  { chave: "despesas_gerais", label: "Despesas Gerais" },
  { chave: "despesas_mao_de_obra", label: "Despesas Mão de Obra" },
  { chave: "investimentos", label: "Investimentos" },
  { chave: "despesas_financeiras", label: "Despesas Financeiras" },
];
